import styled, { css } from "styled-components";

type Variant = "fixed" | "absolute";

// shared overlay primitive used by LoadingPage (full-screen, fixed) and ContentLoadingOverlay (content-area, absolute)
// fades opacity then display: none after transition; absolute variant requires a positioned ancestor
export const StyledLoadingOverlay = styled.div<{ $loading: boolean; $variant: Variant }>`
    ${({ $variant }) =>
        $variant === "fixed"
            ? css`
                  position: fixed;
                  z-index: 9999;
              `
            : css`
                  position: absolute;
                  z-index: 10;
              `}
    inset: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--dit-layout-color-content-background--map);

    display: ${({ $loading }) => ($loading ? "flex" : "none")};
    opacity: ${({ $loading }) => ($loading ? 1 : 0)};
    transition:
        opacity 200ms ease-in,
        display 200ms;
    transition-behavior: allow-discrete;

    @media (prefers-reduced-motion: reduce) {
        transition: none;
    }
`;
